<template>
  <div>
    <el-dropdown-item @click.native="onOpen">
      Для реестра оплат
    </el-dropdown-item>

    <el-dialog
      title="Для реестра оплат"
      :visible.sync="dialog_button"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="90%"
      top="5vh"
      append-to-body
      class="reg-pay-modal"
    >
      <loader-wrapper :loading="loading">
        <el-input
          ref="copyBlock"
          :value="textarea"
          :rows="10"
          type="textarea"
        />
        <el-button type="primary" @click="onCopy">Скопировать</el-button>
      </loader-wrapper>
    </el-dialog>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { fields } from './constants'
import { roundUp } from '@/helpers/functions'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import moment from 'moment'

const LoadDays = RepositoryFactory.get('loadDay')

export default {
  name: 'SendEmailButton',
  components: { LoaderWrapper },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dialog_button: false,
      loading: false,
      textarea: '',
      fields,
    }
  },
  methods: {
    onOpen() {
      this.dialog_button = true
      this.loading = true
      LoadDays.getRegistryPayments(this.id)
        .then(res => this.generateText(res.data))
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    generateText(arr) {
      let text = ''

      arr.map((r, i) => (text += this.getText(r, arr.length - 1 === i)))
      this.textarea = text
    },
    getText(obj, last) {
      let text = ''

      this.fields.map(f => {
        const symbol = f.last ? (last ? '' : '\n') : '\t'

        text += f.arr
          ? this.getFromTTN(obj[f.key])
          : this.checkVal(obj[f.key], f) + symbol
      })

      return text
    },
    getFromTTN(arr) {
      let num = '',
        date = ''

      if (arr.length) {
        arr.map((t, n) => {
          const comma = arr.length - 1 === n ? '' : ', '

          if (t.number) {
            num += '№' + t.number + comma
          }
          if (t.date) {
            date += this.checkVal(t.date, true) + comma
          }
        })
        date = moment(date).format('DD.MM.YYYY')

        return `${num}\t${date}\t`
      }

      return '\t'
    },
    checkVal(value, obj) {
      let val = value || ''

      if (obj.format) {
        val = this.dateToFormat(val, 'onlyDateWithFullTear', true)
      }
      if (obj.weight) {
        val = roundUp(Number(val), 1000) / 1000
      }
      if (obj.num || obj.weight) {
        val = String(val).replace('.', ',')
      }
      if (obj.nds) {
        val = Number(val) + '%'
      }

      return val
    },
    onCopy() {
      this.$refs['copyBlock'].select()
      document.execCommand('copy')
    },
  },
}
</script>

<style lang="sass">
.reg-pay-modal .el-textarea__inner
  white-space: nowrap
</style>
